import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, getUserInfo } from "../services/firebase/firebase";

export const ProtectedRoute = ({ children }) => {
    const [user, loading, error] = useAuthState(auth)
    const navigate = useNavigate()

    useEffect(() => {
        if (loading) return;
        if (!user) return navigate('/')
    }, [user, loading])

    return loading ?
        <div className="center">
            <div className="text-center">
                <div className="spinner-border" role="status" style={{ color: '#beb495', width: '75px', height: '75px' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
        : children

};

export const AdminRoute = ({ children }) => {
    const [user, userLoading, error] = useAuthState(auth)
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()

    useEffect(() => {
        if (userLoading) return;
        if (!user) return navigate('/')
        getUserInfo(user.uid).then(userInfo => {
            if (!userInfo.isAdmin) navigate('/user')
            setLoading(false)
        })
    }, [user, userLoading])

    return loading ?
        <div className="center">
            <div className="text-center">
                <div className="spinner-border" role="status" style={{ color: '#beb495', width: '75px', height: '75px' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
        : children
};